module.exports = __webpack_public_path__ + "images/coverageImg_756f63a.png";